import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "product-dynamic"
};
const _hoisted_2 = {
  key: 0,
  class: "status"
};
const _hoisted_3 = {
  key: 1,
  class: "status"
};
const _hoisted_4 = {
  key: 3,
  class: "status"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.loadingText), 1)) : $data.error ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($data.error), 1), $options.canRetry ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "retry",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.loadProduct && $options.loadProduct(...args))
  }, _toDisplayString($options.retryText), 1)) : _createCommentVNode("", true)])) : $data.currentComponent ? (_openBlock(), _createBlock(_resolveDynamicComponent($data.currentComponent), _normalizeProps(_mergeProps({
    key: 2
  }, $data.componentProps)), null, 16)) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.notFoundText), 1))]);
}